import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/dashbord`;

export const dashboardService = {
  getLiabilitySummary,
  stockConsumption,
  getStockClassificationMovementByTimeFrame,
  getBomWiseAgingData,
  getstockIssuePendingAgingSummary,
  getDutyMovementByTime,
  getVatMovementByTime,
  getFastMovingItems,
  getTopTenCustomers,
  getAgingAqua,
};

function getLiabilitySummary(params) {
  return fetchWrapper.get(`${baseUrl}/liabilitySummaryView${params}`);
}

function stockConsumption(params) {
  return fetchWrapper.get(`${baseUrl}/stockConsumptionView${params}`);
}

function getStockClassificationMovementByTimeFrame(params) {
  return fetchWrapper.get(`${baseUrl}/stockMovement${params}`);
}

function getBomWiseAgingData() {
  return fetchWrapper.get(`${baseUrl}/bomWiseAgin`);
}

function getFastMovingItems() {
  return fetchWrapper.get(`${baseUrl}/fastMovingItems`);
}

function getTopTenCustomers() {
  return fetchWrapper.get(`${baseUrl}/topTenCustomers`);
}

function getstockIssuePendingAgingSummary() {
  return fetchWrapper.get(`${baseUrl}/stockIssuePendingAgingSummary`);
}

function getDutyMovementByTime() {
  return fetchWrapper.get(`${baseUrl}/dutyMovement`);
}

function getVatMovementByTime() {
  return fetchWrapper.get(`${baseUrl}/vatMovement`);
}

function getAgingAqua() {
  return fetchWrapper.get(`${baseUrl}/agingAqua`);
}
